import type { OidcAuth } from 'vue-oidc-client/vue3'
import {
  createOidcAuth as originalCreateOidcAuth,
  LogLevel,
  SignInType,
} from 'vue-oidc-client/vue3'
import { User } from 'oidc-client-ts'

// Re-export SignInType and LogLevel
export { SignInType, LogLevel }

// Extend the OidcAuth interface to add the missing signinRedirectCallback method
export interface ExtendedOidcAuth extends OidcAuth {
  signinRedirectCallback(url?: string): Promise<User>
}

// Create a wrapper for createOidcAuth that uses oidc-client-ts
export function createOidcAuth(
  authName: string,
  signInType: SignInType,
  appUrl: string,
  settings: any,
  logger: Console,
  logLevel: LogLevel,
): ExtendedOidcAuth {
  // Call the original createOidcAuth function
  const auth = originalCreateOidcAuth(authName, signInType, appUrl, settings, logger, logLevel)

  // Add the signinRedirectCallback method to the auth object
  const extendedAuth = auth as ExtendedOidcAuth
  extendedAuth.signinRedirectCallback = function (url?: string): Promise<User> {
    return this.mgr.signinRedirectCallback(url) as Promise<User>
  }

  return extendedAuth
}
